/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ContactSupportPermissionResponse } from '../api-models';
// @ts-ignore
import { ContactSupportRequest } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
/**
 * ContactSupportV2Api - axios parameter creator
 * @export
 */
export const ContactSupportV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Whether the caller may send, plus the values the form prefills.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ContactSupportPermissionGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/contact-support/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends the caller\'s message to SBV support. The recipient, sender and every identifying  field are set server side; the body carries only the reply-to address, an optional phone  number and the message.
         * @param {ContactSupportRequest} [contactSupportRequest] The reply-to address, optional phone number and message.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ContactSupportPost: async (contactSupportRequest?: ContactSupportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/contact-support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactSupportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactSupportV2Api - functional programming interface
 * @export
 */
export const ContactSupportV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactSupportV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Whether the caller may send, plus the values the form prefills.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ContactSupportPermissionGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactSupportPermissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ContactSupportPermissionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends the caller\'s message to SBV support. The recipient, sender and every identifying  field are set server side; the body carries only the reply-to address, an optional phone  number and the message.
         * @param {ContactSupportRequest} [contactSupportRequest] The reply-to address, optional phone number and message.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ContactSupportPost(contactSupportRequest?: ContactSupportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ContactSupportPost(contactSupportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactSupportV2Api - factory interface
 * @export
 */
export const ContactSupportV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactSupportV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Whether the caller may send, plus the values the form prefills.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ContactSupportPermissionGet(options?: AxiosRequestConfig): AxiosPromise<ContactSupportPermissionResponse> {
            return localVarFp.apiV2ContactSupportPermissionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends the caller\'s message to SBV support. The recipient, sender and every identifying  field are set server side; the body carries only the reply-to address, an optional phone  number and the message.
         * @param {ContactSupportV2ApiApiV2ContactSupportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ContactSupportPost(requestParameters: ContactSupportV2ApiApiV2ContactSupportPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2ContactSupportPost(requestParameters.contactSupportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2ContactSupportPost operation in ContactSupportV2Api.
 * @export
 * @interface ContactSupportV2ApiApiV2ContactSupportPostRequest
 */
export interface ContactSupportV2ApiApiV2ContactSupportPostRequest {
    /**
     * The reply-to address, optional phone number and message.
     * @type {ContactSupportRequest}
     * @memberof ContactSupportV2ApiApiV2ContactSupportPost
     */
    readonly contactSupportRequest?: ContactSupportRequest
}

/**
 * ContactSupportV2Api - object-oriented interface
 * @export
 * @class ContactSupportV2Api
 * @extends {BaseAPI}
 */
export class ContactSupportV2Api extends BaseAPI {
    /**
     * 
     * @summary Whether the caller may send, plus the values the form prefills.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactSupportV2Api
     */
    public apiV2ContactSupportPermissionGet(options?: AxiosRequestConfig) {
        return ContactSupportV2ApiFp(this.configuration).apiV2ContactSupportPermissionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends the caller\'s message to SBV support. The recipient, sender and every identifying  field are set server side; the body carries only the reply-to address, an optional phone  number and the message.
     * @param {ContactSupportV2ApiApiV2ContactSupportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactSupportV2Api
     */
    public apiV2ContactSupportPost(requestParameters: ContactSupportV2ApiApiV2ContactSupportPostRequest = {}, options?: AxiosRequestConfig) {
        return ContactSupportV2ApiFp(this.configuration).apiV2ContactSupportPost(requestParameters.contactSupportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
